import { create } from 'zustand';
import { IReportLogisticServiceReason, IReportReasonAttempt } from '../types/services';

interface IStateServices {
  reportReason?: IReportLogisticServiceReason;
  reasonAttempt?: IReportReasonAttempt;
  servicesNumber: number;
  resetDataInLSDetails: boolean;
  resetDataWithoutLoader: boolean;
  originDataChangedCheck: boolean;
  destinationDataChangedCheck: boolean;
  setReportReason: (reportReason?: IReportLogisticServiceReason) => void;
  setReasonAttempt: (reasonAttempt?: IReportReasonAttempt) => void;
  setServicesNumber: (servicesNumber: number) => void;
  setResetDataInLSDetails: (resetDataInLSDetails: boolean) => void;
  setResetDataWithoutLoader: (resetDataWithoutLoader: boolean) => void;
  setOriginDataChangedCheck: (originDataChangedCheck: boolean) => void;
  setDestinationDataChangedCheck: (destinationDataChangedCheck: boolean) => void;
}

const useServiceState = create<IStateServices>(set => ({
  reportReason: undefined,
  reasonAttempt: undefined,
  servicesNumber: 0,
  resetDataInLSDetails: false,
  resetDataWithoutLoader: false,
  originDataChangedCheck: false,
  destinationDataChangedCheck: false,
  setReportReason: reportReason => set({ reportReason }),
  setReasonAttempt: reasonAttempt => set({ reasonAttempt }),
  setServicesNumber: servicesNumber => set({ servicesNumber }),
  setResetDataInLSDetails: resetDataInLSDetails => set({ resetDataInLSDetails }),
  setResetDataWithoutLoader: resetDataWithoutLoader => set({ resetDataWithoutLoader }),
  setOriginDataChangedCheck: originDataChangedCheck => set({ originDataChangedCheck }),
  setDestinationDataChangedCheck: destinationDataChangedCheck => set({ destinationDataChangedCheck }),
}));

export default useServiceState;
